// react-grid-layout referencia `process.env.NODE_ENV` en runtime; en el browser
// con Vite `process` no existe → rompía el drag (handleDragStart). Shim global
// ANTES de cargar la app/RGL.
(globalThis as unknown as { process?: { env: Record<string, string> } }).process ??= {
  env: { NODE_ENV: import.meta.env.MODE },
};

import { createRoot } from 'react-dom/client';
import App from '@/App';
import './index.css';

// Sin StrictMode: el doble-montaje de dev puede interferir con react-grid-layout.
createRoot(document.getElementById('root') as HTMLElement).render(<App />);
